var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-message"},[(_vm.title)?_c('h4',{domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.text)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }